module.exports = __webpack_public_path__ + "img/concrete_services.6003fa30.jpg";